import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidemenu from '../base/sidemenu';
import axios from "axios";
import { formatMobilePhone, formatOfficePhone } from '../../utils/phoneFormatter'

export default function UserWrite() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [authList, setAuthList] = useState([]);
  const [deptList, setDeptList] = useState([]);

  const [form, setForm] = useState({
    name: "",
    mobile_phone: "",
    phone: "",
    department: "",
    auth: "",
    username: "",
    email: "",
    password: "",
    passwordConfirm: "",
  });

  

  useEffect(() => {
    const fetchSelectLists = async () => {
      try {
        const [authRes, deptRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/department`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setAuthList(Array.isArray(authRes.data) ? authRes.data : authRes.data.auth || []);
        setDeptList(Array.isArray(deptRes.data) ? deptRes.data : deptRes.data.department || []);
      } catch (error) {
        console.error("선택박스 데이터 불러오기 실패:", error);
        alert("소속 또는 권한 정보를 불러오는 데 실패했습니다.");
      }
    };

    fetchSelectLists();
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile_phone") {
      const formatted = formatMobilePhone(value);
      setForm(prev => ({ ...prev, [name]: formatted }));
    } else if (name === "phone") {
      const formatted = formatOfficePhone(value);
      setForm(prev => ({ ...prev, [name]: formatted }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
    
  };

  const handleSubmit = async () => {
    
    const {
      username, password, passwordConfirm,
      name, auth, department, email, phone, mobile_phone
    } = form;

    if (password !== passwordConfirm) {
      alert("비밀번호가 일치하지 않습니다.");
      return;
    }

    const payload = {
      username,
      password,
      name,
      auth,
      department,
      email,
      phone,
      mobile_phone
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }
      alert(response.data.message);
      // alert("관리자 등록이 완료되었습니다.");
      navigate("/admin");
      
      } catch (error) {
      console.error("관리자 등록 실패:", error.response?.data || error.message);
      alert("관리자 등록에 실패했습니다.");
      }
  };

  return (
    <div className="flex">
      <Sidemenu />
      <div className="device">
        <h1>관리자 관리</h1>
        <div className="admin_box">
          <h2 className="subpage_title">
            <span className="before"><span className="nametit">관리자 등록</span></span>
          </h2>
          <div className="admin_writebox">
            <div className="table02">
              <table>
                <caption>관리자 등록 표</caption>
                <colgroup>
                  <col width="20%" />
                  <col width="80%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">이름<p className="caution">※</p></th>
                    <td><input type="text" name="name" value={form.name} onChange={handleChange} placeholder="이름을 입력하세요." /></td>
                  </tr>
                  <tr>
                    <th scope="row">아이디<p className="caution">※</p></th>
                    <td><input type="text" name="username" value={form.username} onChange={handleChange} placeholder="ID를 입력하세요." /></td>
                  </tr>
                  <tr>
                    <th scope="row">비밀번호<p className="caution">※</p></th>
                    <td><input type="password" name="password" value={form.password} onChange={handleChange} placeholder="비밀번호를 입력하세요." /></td>
                  </tr>
                  <tr>
                    <th scope="row">비밀번호 확인<p className="caution">※</p></th>
                    <td><input type="password" name="passwordConfirm" value={form.passwordConfirm} onChange={handleChange} placeholder="비밀번호를 다시 입력하세요." /></td>
                  </tr>
                  <tr>
                    <th scope="row">휴대폰 번호</th>
                    <td><input type="text" name="mobile_phone" value={form.mobile_phone} onChange={handleChange} placeholder="휴대폰 번호를 입력하세요." maxLength={13} /></td>
                  </tr>
                  <tr>
                    <th scope="row">내선 번호</th>
                    <td><input type="text" name="phone" value={form.phone} onChange={handleChange} placeholder="내선 번호를 입력하세요." maxLength={13} /></td>
                  </tr>
                  <tr>
                    <th scope="row">이메일</th>
                    <td><input type="email" name="email" value={form.email} onChange={handleChange} placeholder="이메일을 입력하세요." /></td>
                  </tr>
                  <tr>
                    <th scope="row">소속<p className="caution">※</p></th>
                    <td>
                      <select name="department" value={form.department} onChange={handleChange}>
                        <option value="" disabled>소속을 선택하세요.</option>
                        {deptList.map(dept => (
                          <option key={dept.id} value={dept.id}>{dept.name}</option>
                        ))}
                      </select>                      
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">권한<p className="caution">※</p></th>
                    <td>
                      <select name="auth" value={form.auth} onChange={handleChange}>
                        <option value="" disabled>권한을 선택하세요.</option>
                        {authList.map(auth => (
                          <option key={auth.id} value={auth.id}>{auth.name}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="cautiontxt">※ 표시는 필수 입력사항입니다.</p>
            <div className="btn-group">
              <button className="btncolor02" onClick={() => navigate(-1)}>뒤로</button>
              <button className="btncolor01" onClick={handleSubmit}>확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
